import { render, staticRenderFns } from "./LinkdeConvite.vue?vue&type=template&id=72527c6a&scoped=true"
import script from "./LinkdeConvite.vue?vue&type=script&lang=js"
export * from "./LinkdeConvite.vue?vue&type=script&lang=js"
import style0 from "./LinkdeConvite.vue?vue&type=style&index=0&id=72527c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72527c6a",
  null
  
)

export default component.exports